import { Grid, Typography } from '@mui/material';
import { type FC } from 'react';
import { useIntl } from 'react-intl';

import { FormikChip } from '../Formik';

interface TagsProps {
  name?: string;
  label?: string;
  tags?: string[] | null;
}

const Tags: FC<TagsProps> = ({ name = 'tags', label, tags = null }) => {
  const intl = useIntl();
  const resolvedLabel = label ?? intl.formatMessage({ id: 'tagsLabel' });

  return (
    <Grid
      container
      direction='column'
      gap={1}
      py={1}
    >
      {resolvedLabel && (
        <Typography component='span'>
          {resolvedLabel}
          {resolvedLabel.endsWith(':') ? ' ' : ': '}
          {tags?.length ? null : (
            <Typography
              component='span'
              color='text.secondary'
            >
              {intl.formatMessage({ id: 'noTagsAvailable' })}
            </Typography>
          )}
        </Typography>
      )}
      <Grid
        container
        gap={1}
      >
        {tags?.map(tag => (
          <Grid
            item
            key={tag}
          >
            <FormikChip
              name={name}
              label={tag}
              value={tag}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default Tags;
